import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "vld-parent" }, null, -1)

import { onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { getCookie } from "@/service/local/cookies.service";
import { accountInfoAxios } from "@/service/account.service";
import jwt_decode from "jwt-decode";
import "vue3-loading-overlay/dist/vue3-loading-overlay.css";
import { useRoute, useRouter } from "vue-router";
import { ROU_NAME } from "./router/router.name";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const i18n = useI18n();
const acToken = getCookie("access_T");
const router = useRouter();
const route = useRoute();

onMounted(async () => {
  let locale = String(localStorage.getItem("lang"));
  if (!locale) {
    locale = navigator.language;
  }
  locale = locale.substring(0, 2);
  if (locale !== "ko") locale = "en";
  i18n.locale.value = locale;
  localStorage.setItem("lang", i18n.locale.value);

  const sessionCheck = async () => {
    if (acToken) {
      const decoded: any = jwt_decode(acToken);
      await accountInfoAxios(decoded.sub);
      if (route.fullPath === "/") {
        router.push({ name: ROU_NAME.DASHBOARD });
      } else {
        return;
      }
    } else {
      router.replace(route.fullPath);
    }
  };
  await sessionCheck();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_router_view)
  ]))
}
}

})